import React from 'react';
import { HStack, Stack } from '@chakra-ui/core';
import { RecruiterList } from './recruiters/RecruiterList';
import { PositionsView } from './positions/PositionsView';
import { PositionRecruiterView } from './positionRecruiter/PositionRecruiterView';
import { PositionFilters } from './positions/PositionFilters';
import { BulkAssignActionsContainer } from '../BulkRecruiterWatchAndFollow/bulkAssignActions/BulkAssignActionsContainer';

function RecruiterWatchAndFollowComponent() {
  return (
    <Stack spacing={0} marginBottom="2px">
      <PositionFilters />
      <HStack justify="center" spacing="2px">
        <RecruiterList />
        <Stack flexGrow={1} spacing="2px">
          <PositionsView />
          <BulkAssignActionsContainer />
        </Stack>
        <PositionRecruiterView />
      </HStack>
    </Stack>
  );
}
export const RecruiterWatchAndFollow = React.memo(RecruiterWatchAndFollowComponent);
